/**
 * @type {import("axios").AxiosInstance}
 */
import repository from "../repository";
const path = "/v2/user";
/**
 * @typedef {Object} User
 * @property {String} _id
 */
export default {
  /**
   *@returns {Promise<User>}
   */
  async get({ simple = true } = {}) {
    let userdoc = await repository
      .get(`${path}${simple ? "?simple" : ""}`)
      .then(response => {
        // console.log(response);
        return Promise.resolve(response.data.object);
      });
    let permissions = await repository
      .get(`${path}/permissions`)
      .then(response => {
        return Promise.resolve(response.data.object);
      })
      .catch(err => {
        return Promise.resolve([]);
      });
    userdoc["permissions"] = permissions;
    return userdoc;
  },
  /**
   * @typedef {Object} Organization
   * @property {String} _id
   * @property {String} name
   * @property {String} subdomain
   * @property {String} imglink
   */
  /**
   * @typedef {Object} Document
   * @property {Boolean} canCreate
   * @property {Array<Organization>} organizations
   */
  /**
   * @returns {Document}
   */
  async getOrganizations() {
    let organizationdata = await repository
      .get(`${path}/organizations`)
      .then(response => {
        return Promise.resolve(response.data.object);
      });
    return organizationdata;
  },
  async createOrganization({ name, subdomain }) {
    let organizationdata = await repository
      .post(`${path}/organizations`, {
        name,
        subdomain
      })
      .then(response => {
        return Promise.resolve(response.data.object);
      });
    return organizationdata;
  }
};
